
import { SubscriptionPlansTable } from "@/components/admin/subscriptions/SubscriptionPlansTable";
import { useSubscriptions } from "@/hooks/useSubscriptions";
import { toast } from "sonner";
import { SubscriptionPlan } from "@/lib/types";

export default function SubscriptionPlansListPage() {
  const { 
    useSubscriptionPlansQuery,
    useDeleteSubscriptionPlanMutation
  } = useSubscriptions();
  
  const { data: plans = [], isLoading: plansLoading, refetch: refetchPlans } = useSubscriptionPlansQuery();
  const deletePlan = useDeleteSubscriptionPlanMutation();
  
  const handleDeletePlan = async (planId: string) => {
    try {
      await deletePlan.mutateAsync(planId);
      toast.success("Subscription plan deleted successfully");
      refetchPlans();
    } catch (error) {
      console.error("Failed to delete plan:", error);
      toast.error("Failed to delete subscription plan. Please try again.");
    }
  };

  return (
    <div className="container py-6 space-y-6">
      <h1 className="text-2xl font-bold">Subscription Plans</h1>
      
      <SubscriptionPlansTable
        plans={plans}
        onDeletePlan={handleDeletePlan}
        isLoading={plansLoading}
      />
    </div>
  );
}
